"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { createContext, useContext } from 'react';

const FIELDS_TO_SHOW = 5;
const DataBuilderContext = createContext({
  drilldownStack: [],
  isAdminMode: false,
  isReadOnly: false,
  showNullValueFields: false,
  hideReadOnlyFields: false,
  frozenFieldsLocators: [],
  errorFieldsLocators: [],
  editableVariablesSchemaLocators: [],
  collapsedDataBuilder: false,
  initialVisibleFieldCount: FIELDS_TO_SHOW
});
DataBuilderContext.displayName = "DataBuilderContext";
function useDataBuilder() {
  return useContext(DataBuilderContext);
}

export { DataBuilderContext, useDataBuilder as default };
